import { useEffect } from 'react';

const SEOHead = ({ title, description, path, type = 'website', image, keywords, schema }) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper to set or create a meta tag
    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Standard meta
    setMeta('name', 'description', description);
    if (keywords) {
      setMeta('name', 'keywords', keywords);
    }

    // Open Graph for social sharing
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', type);
    if (path) {
      setMeta('property', 'og:url', `https://www.chibidash.com${path}`);
    }
    if (image) {
      setMeta('property', 'og:image', image);
    }
    setMeta('property', 'og:site_name', 'ChibiDash');

    // Twitter Card
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    if (image) {
      setMeta('name', 'twitter:image', image);
    }

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && path) {
      canonical.setAttribute('href', `https://www.chibidash.com${path}`);
    }

    // Inject per-page JSON-LD structured data
    let schemaScript = document.querySelector('script[data-seo-schema]');
    if (schema) {
      if (!schemaScript) {
        schemaScript = document.createElement('script');
        schemaScript.setAttribute('type', 'application/ld+json');
        schemaScript.setAttribute('data-seo-schema', 'true');
        document.head.appendChild(schemaScript);
      }
      schemaScript.textContent = JSON.stringify(schema);
    } else if (schemaScript) {
      schemaScript.remove();
    }
  }, [title, description, path, type, image, keywords, schema]);

  return null;
};

export default SEOHead;
